/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Guide_When_BodyInputs */

const en_fw_guide_when_body = /** @type {(inputs: Fw_Guide_When_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Firefly Wedding anime premiered on October 9, 2026 on Fuji TV’s Noitamina block. New episodes air every Friday at 23:30 JST, AT-X joins from October 16, and Japanese streaming services follow from midnight. Outside Asia, Crunchyroll simulcasts the series. Schedule trackers currently list 12 episodes, which would put the finale in late December 2026.`)
};

const zh_fw_guide_when_body = /** @type {(inputs: Fw_Guide_When_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`萤火之嫁动画于 2026 年 10 月 9 日在富士电视台ノイタミナ档首播，此后每周五 23:30（日本时间）更新，AT-X 自 10 月 16 日起追加播出，日本各流媒体平台于午夜后陆续上线。亚洲以外由 Crunchyroll 同步播出。排期站目前列出共 12 话，按此推算完结篇将在 2026 年 12 月下旬播出。`)
};

/**
* | output |
* | --- |
* | "The Firefly Wedding anime premiered on October 9, 2026 on Fuji TV’s Noitamina block. New episodes air every Friday at 23:30 JST, AT-X joins from October 16, ..." |
*
* @param {Fw_Guide_When_BodyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_guide_when_body = /** @type {((inputs?: Fw_Guide_When_BodyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Guide_When_BodyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_guide_when_body(inputs)
	return zh_fw_guide_when_body(inputs)
});
export { fw_guide_when_body as "fw.guide.when.body" }